import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import actions from './actions'
import selectors from './selectors'

import TravelsMap from './components/TravelsMap';

class Travels extends Component {
    componentDidMount() {
        this.props.fetchData();
    }
    
    render() {
        const {geojson, manuscripts} = this.props;
        return (
            <div style={{height:600}}>
                <TravelsMap manuscripts={manuscripts} geojson={geojson}/>
            </div>
        )
    }
}

export default connect(selectors, actions)(Travels);


// WEBPACK FOOTER //
// ./src/modules/Travels/container.js